export const EMAIL_BUILDER_SETTINGS_DEFER_AUTOSAVE_ATTR =
  "data-email-builder-settings-defer-autosave";

let settingsTextAutosaveDeferred = false;
let settingsGestureAutosaveDeferralDepth = 0;
let settingsValidationAutosaveBlocked = false;
const listeners = new Set<() => void>();

function notifyEmailBuilderSettingsAutosaveDeferralListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function isEmailBuilderSettingsAutosaveDeferred(): boolean {
  return (
    settingsTextAutosaveDeferred ||
    settingsGestureAutosaveDeferralDepth > 0 ||
    settingsValidationAutosaveBlocked
  );
}

export function blockEmailBuilderSettingsAutosaveForValidation(): void {
  if (settingsValidationAutosaveBlocked) {
    return;
  }

  settingsValidationAutosaveBlocked = true;
  notifyEmailBuilderSettingsAutosaveDeferralListeners();
}

export function releaseEmailBuilderSettingsValidationAutosaveBlock(): void {
  if (!settingsValidationAutosaveBlocked) {
    return;
  }

  settingsValidationAutosaveBlocked = false;
  notifyEmailBuilderSettingsAutosaveDeferralListeners();
}

export function beginEmailBuilderSettingsGestureAutosaveDeferral(): void {
  settingsGestureAutosaveDeferralDepth += 1;
  if (settingsGestureAutosaveDeferralDepth === 1) {
    notifyEmailBuilderSettingsAutosaveDeferralListeners();
  }
}

export function endEmailBuilderSettingsGestureAutosaveDeferral(): void {
  if (settingsGestureAutosaveDeferralDepth === 0) {
    return;
  }

  settingsGestureAutosaveDeferralDepth -= 1;
  if (settingsGestureAutosaveDeferralDepth === 0) {
    notifyEmailBuilderSettingsAutosaveDeferralListeners();
  }
}

export function emailBuilderSettingsAutosaveGestureHandlers(continuousHistory: {
  begin: () => void;
  end: () => void;
}): {
  onGestureStart: () => void;
  onGestureEnd: () => void;
} {
  return {
    onGestureStart: () => {
      beginEmailBuilderSettingsGestureAutosaveDeferral();
      continuousHistory.begin();
    },
    onGestureEnd: () => {
      continuousHistory.end();
      endEmailBuilderSettingsGestureAutosaveDeferral();
    },
  };
}

function isEmailBuilderSettingsDeferAutosaveFocusTarget(
  element: Element | null,
): boolean {
  if (element === null) {
    return false;
  }

  return element.closest(`[${EMAIL_BUILDER_SETTINGS_DEFER_AUTOSAVE_ATTR}]`) !== null;
}

export function notifyEmailBuilderSettingsTextInputFocused(): void {
  if (settingsTextAutosaveDeferred) {
    return;
  }

  settingsTextAutosaveDeferred = true;
  notifyEmailBuilderSettingsAutosaveDeferralListeners();
}

export function notifyEmailBuilderSettingsTextInputBlurred(): void {
  window.requestAnimationFrame(() => {
    if (isEmailBuilderSettingsDeferAutosaveFocusTarget(document.activeElement)) {
      return;
    }

    if (!settingsTextAutosaveDeferred) {
      return;
    }

    settingsTextAutosaveDeferred = false;
    notifyEmailBuilderSettingsAutosaveDeferralListeners();
  });
}

export function releaseEmailBuilderSettingsAutosaveDeferral(): void {
  const wasDeferred = isEmailBuilderSettingsAutosaveDeferred();
  settingsTextAutosaveDeferred = false;
  settingsGestureAutosaveDeferralDepth = 0;
  settingsValidationAutosaveBlocked = false;

  if (wasDeferred) {
    notifyEmailBuilderSettingsAutosaveDeferralListeners();
  }
}

export function subscribeEmailBuilderSettingsAutosaveDeferral(
  listener: () => void,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
